import PublicPb from '../../pb/resultresponse.pb';
import PbAjax from '../c-up-pbajax';
import errorHandler, {REQ_ERROR, TIMEOUT} from './error-handle';

/**
 * 在对象中查找key
 * @param obj
 * @param val
 * @returns {*}
 */
function findKey(obj, val) {
    let k = null;
    Object.keys(obj).map(item => {
        if (obj[item] === val) {
            k = item;
        }
    });
    return k;
}

/**
 * pb请求数据
 * @param {Object} config pbajax 配置
 * @param {Object} params 参数
 * @param {Object} pbObj 解析加密参数的pd对象
 */
function baseAjax(config, params, pbObj) {
    let data = new pbObj.Request(params);
    let pbajax = new PbAjax();
    console.log(`%c请求参数 ${config.api}`, 'color:blue', params);
    return new Promise((resolve, reject) => {
        pbajax.do(
            $.extend(true, {
                header: {
                    userToken: UG.getUser().userToken,
                    lang: UG.lang.type,
                    'Accept-Language': UG.lang.type
                }
            }, config),
            data,
            resp => {
                let dataWrapper = PublicPb.Result.decode(resp);

                console.groupCollapsed(`%c 返回的数据【${findKey(Code, dataWrapper.code)}】 ===>  ${config.api}`, 'color:green');
                console.log(dataWrapper);
                console.groupEnd();

                // 标识没有登录，直接去登录就好了
                if (dataWrapper.code === 8192) {
                    UG.clearUser();
                    UG.router.push('/login');
                } else {
                    let data = null;
                    // 不管对不对先解析data吧
                    if (dataWrapper.data && dataWrapper.data.value) {
                        data = pbObj.Response.decode(dataWrapper.data.value);
                        console.groupCollapsed(`%c 解析后的数据 ${config.api}`, 'color:red');
                        console.log(data);
                        console.groupEnd();
                    }
                    // 先解析正确的data
                    if (dataWrapper.code === 1 || dataWrapper.code === 1064960 || dataWrapper.code === 1069056) {
                        return resolve(data);
                    } else {
                        // 先提示一下错误码
                        errorHandler(dataWrapper.code);
                        // 有data就返回data
                        return reject(data || dataWrapper.code);
                    }
                }

                reject(dataWrapper.code);
            },
            () => {
                errorHandler(TIMEOUT);
                reject(TIMEOUT);
            },
            () => {
                errorHandler(REQ_ERROR);
                reject(REQ_ERROR);
            }
        );
    });
}

/**
 * @description 一个使用服务提供的柯里化函数，可以通过下面函数生成不同用途的函数
 * 1、下面创建一个统一的服务
 * const ugMallService = serviceFactory('mall');
 * 2、实例化一个方法
 * const getUgMallRanking = ugMallService('/ug/mall/ranking/list', UgMallRankingPb.UG.Mall.Ranking);
 * 3、开始调用方法
 * getUgMallRanking(params).then(data=>console.log(data)).catch(err=>console.log(err));
 *
 * 这样做的好处就是，每个地方不需要将所有的参数传递一遍，这样做的原因
 * 1、多个接口对应的是同一个服务，所以服务可以缓存
 * 2、定义方法的时候可以将请求参数无关的参数抽离，提取到每个文件的顶部，如果URL或者pb文件有变更，不需要在业务代码中到处找请求去修改
 *
 * @param {Object} service java对应的service名称，一般是php那边配置的
 * @returns {function({config?: *, header?: *, params?: *, pbObj?: *}=): *}
 */
function serviceFactory(service) {
    /**
     * @param {String} api 请求url
     * @param {Object} pbObj 解析数据的pb对象
     * @param {Object} config pbajax中的附加config
     */
    return (api, pbObj, config = {}) => {
        /**
         * @param {Object} params 请求参数
         */
        return params => baseAjax(
            //  合并配置，注意这个true是深度合并
            $.extend(true, config, {service, api}),
            //  请求参数
            params,
            //  加密解密的pb对象，包含Request和Response
            pbObj
        );
    };
}

/**
 * Gift相关接口
 * @param {*} config
 * @param {Object} header
 * @param {*} params
 * @param {*} pbObj
 */
function giftAjax({config = {}, header = null, params = {}, pbObj = {}} = {}) {
    return baseAjax({
        service: 'universal-gift',
        ...config,
        header: {
            ...header
        }
    }, params, pbObj);
}

/**
 * UGMall相关接口
 * @param {*} config
 * @param {*} header
 * @param {*} params
 * @param {*} pbObj
 */
function ugMallAjax({config = {}, header = null, params = {}, pbObj = {}} = {}) {
    return baseAjax({
        service: 'mall',
        ...config,
        header: {
            ...header
        }
    }, params, pbObj);
}

/**
 * 用户注册相关接口
 * @param {*} config
 * @param {*} header
 * @param {*} params
 * @param {*} pbObj
 */
function safeAjax({config = {}, header = null, params = {}, pbObj = {}} = {}) {
    return baseAjax({
        service: 'safe',
        ...config,
        header: {
            ...header
        }
    }, params, pbObj);
}

const giftoMallService = serviceFactory('gifto_mall');
const userService = serviceFactory('service');

export {
    baseAjax,
    giftAjax,
    ugMallAjax,
    safeAjax,
    serviceFactory,
    userService,
    giftoMallService,
    REQ_ERROR,
    TIMEOUT
};



// WEBPACK FOOTER //
// ./js/component/api/index.js